// extracted by mini-css-extract-plugin
module.exports = {"dateCardLabel":"DateCard_dateCardLabel_QFJaw","dateCardValue":"DateCard_dateCardValue_2jSLg"};